import React from 'react'
import Document from 'components/document/index.js'

export default (props) => <Document.row {...props} />
